{
  "familyId": "SPR-LEESTEKEN-PUNT-KOMMA",
  "questions": [
    {
      "id": "SPR-LEESTEKEN-PUNT-KOMMA-001",
      "familyId": "SPR-LEESTEKEN-PUNT-KOMMA",
      "module": "SpellingRegel",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "leestekens",
      "subSkill": "leesteken_punt_komma",
      "questionType": "multiple_choice",
      "question": "Welk leesteken hoort op de plek van het streepje? 'Hoewel de zon schijnt _ is het koud buiten.'",
      "options": ["een komma (,)", "een punt (.)", "een uitroepteken (!)", "een dubbele punt (:)"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Komma na een bijzin vooraan", "content": "Als een zin begint met een bijzin (een zin die start met 'hoewel', 'omdat', 'als', 'terwijl' enz.), zet je een komma tussen de bijzin en de hoofdzin. Voorbeeld: 'Hoewel de zon schijnt, is het koud.'", "icon": "lightbulb" } }
      ],
      "conceptId": "leesteken_komma_bijzin_vooraan",
      "variantIndex": 1,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "De zin begint met een bijzin: 'Hoewel de zon schijnt'. Daarna komt de hoofdzin: 'is het koud buiten'. Tussen een bijzin vooraan en de hoofdzin zet je altijd een komma. Truc: lees alleen de hoofdzin hardop — 'is het koud buiten' klinkt af. Daarvoor staat een bijzin → komma ertussen.",
        "solutionSteps": [
          "Herken de bijzin vooraan: 'Hoewel de zon schijnt'",
          "Daarna komt de hoofdzin: 'is het koud buiten'",
          "Tussen bijzin vooraan en hoofdzin → altijd een komma"
        ],
        "distractorExplanations": {
          "0": "Goed! Na een bijzin vooraan ('Hoewel de zon schijnt') komt een komma.",
          "1": "Je dacht waarschijnlijk dat er een punt moest. Maar dan breek je de zin doormidden — de hoofdzin 'is het koud buiten' kan niet alleen staan zonder de bijzin. Een komma houdt de zin heel. Onthoud: bijzin + hoofdzin = één zin, gescheiden door een komma.",
          "2": "Een uitroepteken gebruik je bij verbazing of een bevel, en altijd aan het einde van een zin. Hier zit je middenin de zin. Onthoud: uitroepteken = einde van een zin met emotie of bevel.",
          "3": "Een dubbele punt gebruik je voor een opsomming of uitleg ('Hij kocht drie dingen: brood, kaas en melk'). Hier gaat het om een bijzin en hoofdzin. Onthoud: dubbele punt = 'namelijk' of opsomming."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "spr.leesteken-punt-ipv-komma", "label": "Kiest punt waar komma past", "optionIndex": 1 },
          { "id": "spr.leesteken-uitroep-verkeerd", "label": "Kiest uitroepteken bij mededeling", "optionIndex": 2 },
          { "id": "spr.leesteken-dubbele-punt-verkeerd", "label": "Kiest dubbele punt waar komma past", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SPR-LEESTEKEN-PUNT-KOMMA-002",
      "familyId": "SPR-LEESTEKEN-PUNT-KOMMA",
      "module": "SpellingRegel",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "leestekens",
      "subSkill": "leesteken_punt_komma",
      "questionType": "multiple_choice",
      "question": "Welke zin heeft de komma op de juiste plek?",
      "options": [
        "Ik heb brood kaas, en melk gekocht.",
        "Ik heb, brood kaas en melk gekocht.",
        "Ik heb brood, kaas en melk gekocht.",
        "Ik heb brood kaas en, melk gekocht."
      ],
      "correctAnswer": 2,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Komma bij opsomming", "content": "Bij een opsomming zet je een komma tussen de woorden, behalve voor 'en'. Dus: brood, kaas en melk.", "icon": "lightbulb" } }
      ],
      "conceptId": "leesteken_komma_opsomming",
      "variantIndex": 2,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Bij een opsomming zet je een komma tussen elk woord, behalve voor het laatste woord met 'en': brood, kaas en melk.",
        "solutionSteps": ["Herken de opsomming: brood, kaas, melk", "Komma tussen de woorden", "Geen komma voor 'en'", "brood, kaas en melk"],
        "distractorExplanations": {
          "0": "De komma staat op de verkeerde plek. Bij een opsomming zet je de komma na elk woord behalve het laatste. Onthoud: brood, kaas en melk.",
          "1": "De komma staat na 'heb', maar dat hoort niet. De komma hoort tussen de woorden in de opsomming. Onthoud: komma = tussen de opgesomde woorden.",
          "2": "Goed! Komma na 'brood', geen komma voor 'en'.",
          "3": "De komma staat voor 'melk', maar die hoort na 'brood'. Bij een opsomming: komma na elk woord behalve het laatste."
        }
      },
      "pedagogy": {
        "dok": 2
      }
    },
    {
      "id": "SPR-LEESTEKEN-PUNT-KOMMA-003",
      "familyId": "SPR-LEESTEKEN-PUNT-KOMMA",
      "module": "SpellingRegel",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "leestekens",
      "subSkill": "leesteken_punt_komma",
      "questionType": "multiple_choice",
      "question": "In welke zin ontbreekt een punt?",
      "options": [
        "Ik ga naar school. Daarna ga ik voetballen. Het wordt leuk.",
        "Ik ga naar school. Daarna ga ik voetballen Het wordt leuk.",
        "Ik ga. Naar school daarna. Ga ik voetballen. Het wordt leuk.",
        "Ik ga naar school, daarna ga ik voetballen, het wordt leuk."
      ],
      "correctAnswer": 1,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Punt aan het einde van elke zin", "content": "Elke afgeronde zin eindigt met een punt. Als je tussen twee volledige zinnen geen punt zet, lopen ze door elkaar (een 'zinnenfout'). Lees hardop: waar pauzeer je natuurlijk? Daar hoort een punt.", "icon": "lightbulb" } }
      ],
      "conceptId": "leesteken_punt_missend",
      "variantIndex": 3,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Optie 2 mist de punt tussen 'voetballen' en 'Het'. 'Daarna ga ik voetballen' is een volledige zin en moet eindigen met een punt voordat de volgende zin ('Het wordt leuk.') begint. Optie 1 is correct geschreven. Optie 3 zet punten op verkeerde plekken (middenin zinnen). Optie 4 gebruikt komma's tussen volledige zinnen — dat moeten punten zijn.",
        "solutionSteps": [
          "Lees elke zin hardop en zoek waar je natuurlijk pauzeert",
          "Optie 1: drie volledige zinnen, elk met een punt → correct ✓",
          "Optie 2: 'voetballen Het' loopt door zonder punt → FOUT",
          "Optie 3: punten staan midden in zinnen → FOUT",
          "Optie 4: komma's tussen volledige zinnen → FOUT (moeten punten zijn)"
        ],
        "distractorExplanations": {
          "0": "Deze zin is juist correct geschreven: drie volledige zinnen, elk met een punt. De fout zit ergens anders.",
          "1": "Goed! Tussen 'voetballen' en 'Het wordt leuk' ontbreekt een punt. Twee volledige zinnen mogen niet zonder leesteken aan elkaar geplakt zijn.",
          "2": "Hier staan de punten op verkeerde plekken (middenin de zinnen), maar de vraag was waar een punt ONTBREEKT. In deze optie zijn er te veel punten op verkeerde plekken — dat is een ander type fout.",
          "3": "Hier worden komma's gebruikt tussen drie volledige zinnen. Dat is ook een fout (kommafout, geen ontbrekende punt). De vraag was waar een punt ontbreekt — dat is duidelijker te zien in optie 2."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "spr.leesteken-punt-ipv-komma", "label": "Komma waar punt hoort (run-on)", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SPR-LEESTEKEN-PUNT-KOMMA-004",
      "familyId": "SPR-LEESTEKEN-PUNT-KOMMA",
      "module": "SpellingRegel",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "leestekens",
      "subSkill": "leesteken_punt_komma",
      "questionType": "multiple_choice",
      "question": "Wanneer gebruik je GEEN komma?",
      "options": [
        "Bij een opsomming van woorden",
        "Voor het woord 'maar'",
        "Na een bijzin aan het begin van een zin",
        "Tussen onderwerp en persoonsvorm"
      ],
      "correctAnswer": 3,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Geen komma tussen onderwerp en PV", "content": "Tussen het onderwerp en de persoonsvorm komt NOOIT een komma. Fout: 'De hond, blaft.' Goed: 'De hond blaft.'", "icon": "lightbulb" } }
      ],
      "conceptId": "leesteken_geen_komma",
      "variantIndex": 4,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Tussen het onderwerp en de persoonsvorm komt nooit een komma. 'De hond blaft' — geen komma tussen 'hond' en 'blaft'. Bij opsommingen, voor 'maar', en na een bijzin aan het begin wél een komma.",
        "solutionSteps": ["Onderwerp + persoonsvorm = NOOIT een komma", "Opsomming, 'maar', bijzin = WEL een komma"],
        "distractorExplanations": {
          "0": "Bij een opsomming gebruik je juist WEL een komma: appels, peren en bananen. Onthoud: opsomming = komma.",
          "1": "Voor 'maar' gebruik je juist WEL een komma: 'Het regent, maar ik ga toch.' Onthoud: voor 'maar' altijd een komma.",
          "2": "Na een bijzin aan het begin gebruik je juist WEL een komma: 'Als het regent, blijf ik binnen.' Onthoud: bijzin vooraan = komma erna.",
          "3": "Goed! Tussen onderwerp en persoonsvorm komt nooit een komma."
        }
      },
      "pedagogy": {
        "dok": 2
      }
    },
    {
      "id": "SPR-LEESTEKEN-PUNT-KOMMA-005",
      "familyId": "SPR-LEESTEKEN-PUNT-KOMMA",
      "module": "SpellingRegel",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "leestekens",
      "subSkill": "leesteken_punt_komma",
      "questionType": "fill_in",
      "question": "Zet het juiste leesteken op de plek van het streepje: 'Ik heb een hond _ een kat en een vis.' Typ alleen het leesteken.",
      "correctAnswer": ",",
      "data": {
        "acceptedAnswers": [","],
        "caseSensitive": false,
        "placeholder": "?"
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Komma bij opsomming", "content": "Bij een opsomming zet je een komma tussen de woorden, behalve voor 'en'. Dus: hond, kat en vis.", "icon": "lightbulb" } }
      ],
      "conceptId": "leesteken_komma_fill",
      "variantIndex": 5,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Dit is een opsomming: hond, kat en vis. Na 'hond' komt een komma, want bij een opsomming zet je een komma tussen de woorden. Voor 'en' komt geen komma. Onthoud de regel: komma tussen elk woord in de opsomming, behalve voor 'en'.",
        "solutionSteps": ["Herken de opsomming: hond, kat en vis", "Komma na 'hond'", "Geen komma voor 'en'"]
      }
    },
    {
      "id": "SPR-LEESTEKEN-PUNT-KOMMA-006",
      "familyId": "SPR-LEESTEKEN-PUNT-KOMMA",
      "module": "SpellingRegel",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "leestekens",
      "subSkill": "leesteken_punt_komma",
      "questionType": "error_spotting",
      "question": "Zoek de leestekenfout in deze tekst en verbeter hem.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "text": "Ik heb appels peren en bananen gekocht. Daarna ging ik naar huis.",
        "errors": [
          {
            "word": "appels peren",
            "position": 2,
            "correction": "appels, peren",
            "explanation": "Bij een opsomming zet je een komma tussen de woorden: appels, peren en bananen."
          }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Komma bij opsomming", "content": "Bij een opsomming zet je een komma tussen de woorden, behalve voor 'en'.\nFout: appels peren en bananen\nGoed: appels, peren en bananen", "icon": "lightbulb" } }
      ],
      "conceptId": "leesteken_komma_error_spotting",
      "variantIndex": 6,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Er ontbreekt een komma in de opsomming. Het moet zijn: 'appels, peren en bananen'. Bij een opsomming zet je een komma tussen elk woord, behalve voor 'en'. De tweede zin is correct — de punt staat goed.",
        "solutionSteps": [
          "Herken de opsomming: appels, peren, bananen",
          "Komma na 'appels': appels, peren en bananen",
          "Geen komma voor 'en' (dat is de regel)",
          "De punt na de eerste zin is correct ✓"
        ]
      },
      "pedagogy": {
        "dok": 2
      }
    },
    {
      "id": "SPR-LEESTEKEN-PUNT-KOMMA-007",
      "familyId": "SPR-LEESTEKEN-PUNT-KOMMA",
      "module": "SpellingRegel",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "leestekens",
      "subSkill": "leesteken_punt_komma",
      "questionType": "true_false_series",
      "question": "Beoordeel of elke bewering over leestekens klopt.",
      "data": {
        "statements": [
          { "text": "Bij een opsomming zet je een komma tussen de woorden.", "isTrue": true },
          { "text": "Voor het woord 'en' in een opsomming komt een komma.", "isTrue": false },
          { "text": "Elke zin eindigt met een punt.", "isTrue": true },
          { "text": "Tussen onderwerp en werkwoord komt een komma.", "isTrue": false },
          { "text": "Na een bijzin aan het begin komt een komma.", "isTrue": true }
        ]
      },
      "correctAnswer": [true, false, true, false, true],
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Kommaregels", "content": "Komma bij: opsomming (appels, peren en bananen), voor 'maar', na bijzin vooraan. Geen komma: voor 'en' in opsomming, tussen onderwerp en werkwoord.", "icon": "lightbulb" } }
      ],
      "conceptId": "leesteken_tf_series",
      "variantIndex": 7,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Opsomming → komma ✓. Voor 'en' → GEEN komma ✗. Zin eindigt met punt ✓. Onderwerp + werkwoord → GEEN komma ✗. Bijzin vooraan → komma erna ✓. Regel: de komma verbindt of scheidt zinsdelen, maar nooit tussen onderwerp en werkwoord.",
        "solutionSteps": [
          "Opsomming: appels, peren en bananen → komma ✓",
          "Voor 'en': geen komma (het laatste woord) ✗",
          "Einde zin: altijd een punt ✓",
          "Onderwerp + werkwoord: nooit een komma ✗",
          "Bijzin vooraan: 'Als het regent, blijf ik binnen.' → komma ✓"
        ]
      },
      "pedagogy": {
        "dok": 2
      }
    },
    {
      "id": "SPR-LEESTEKEN-PUNT-KOMMA-008",
      "familyId": "SPR-LEESTEKEN-PUNT-KOMMA",
      "module": "SpellingRegel",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "leestekens",
      "subSkill": "leesteken_punt_komma",
      "questionType": "matching",
      "question": "Koppel elke situatie aan het juiste leesteken.",
      "data": {
        "pairs": [
          { "left": "Einde van een zin", "right": "Punt (.)" },
          { "left": "Tussen woorden in een opsomming", "right": "Komma (,)" },
          { "left": "Bij verbazing of een bevel", "right": "Uitroepteken (!)" },
          { "left": "Bij een vraag", "right": "Vraagteken (?)" }
        ]
      },
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Leestekens kiezen", "content": "Punt: einde van een gewone zin. Komma: opsomming of verbinding. Uitroepteken: verbazing of bevel. Vraagteken: bij een vraag.", "icon": "lightbulb" } }
      ],
      "conceptId": "leesteken_matching",
      "variantIndex": 8,
      "citoDifficulty": 0.26,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Einde zin → punt. Opsomming → komma. Verbazing/bevel → uitroepteken. Vraag → vraagteken. Elk leesteken heeft een eigen functie.",
        "solutionSteps": [
          "Punt → einde van een gewone zin",
          "Komma → tussen woorden in een opsomming",
          "Uitroepteken → verbazing of bevel",
          "Vraagteken → bij een vraag"
        ]
      },
      "pedagogy": {
        "dok": 1
      }
    },
    {
      "id": "SPR-LEESTEKEN-PUNT-KOMMA-009",
      "familyId": "SPR-LEESTEKEN-PUNT-KOMMA",
      "module": "SpellingRegel",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "leestekens",
      "subSkill": "leesteken_punt_komma",
      "questionType": "sentence_error_judge",
      "question": "Beoordeel elke zin: zijn de leestekens correct?",
      "data": {
        "sentences": [
          { "text": "Ik heb appels, peren en bananen gekocht.", "hasError": false },
          { "text": "De hond, blaft hard.", "hasError": true, "correction": "De hond blaft hard.", "explanation": "Tussen het onderwerp (de hond) en de persoonsvorm (blaft) komt nooit een komma." },
          { "text": "Het regent, maar ik ga toch.", "hasError": false },
          { "text": "We gaan naar school. Het is maandag.", "hasError": false }
        ]
      },
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Kommaregels controleren", "content": "Geen komma tussen onderwerp en persoonsvorm. Wel komma bij opsomming en voor 'maar'. Elke zin eindigt met een punt.", "icon": "lightbulb" } }
      ],
      "conceptId": "leesteken_error_judge",
      "variantIndex": 9,
      "citoDifficulty": 0.34,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "De fout zit in zin 2: 'De hond, blaft hard.' Tussen het onderwerp (de hond) en de persoonsvorm (blaft) komt nooit een komma. Het moet zijn: 'De hond blaft hard.' De andere zinnen zijn correct: opsomming met komma ✓, komma voor 'maar' ✓, punt aan het einde ✓.",
        "solutionSteps": [
          "Zin 1: opsomming met komma → correct ✓",
          "Zin 2: komma tussen onderwerp en werkwoord → fout ✗",
          "Zin 3: komma voor 'maar' → correct ✓",
          "Zin 4: twee zinnen met punt → correct ✓"
        ]
      },
      "pedagogy": {
        "dok": 2
      }
    }
  ]
}